import PDFAcroButton from '../../core/acroform/PDFAcroButton.js';
import { AcroButtonFlags } from '../../core/acroform/flags.js';
class PDFAcroPushButton extends PDFAcroButton {
    static fromDict = (dict, ref) => new PDFAcroPushButton(dict, ref);
    static create = (context) => {
        const dict = context.obj({
            FT: 'Btn',
            Ff: AcroButtonFlags.PushButton,
            Kids: [],
        });
        const ref = context.register(dict);
        return new PDFAcroPushButton(dict, ref);
    };
}
export default PDFAcroPushButton;
//# sourceMappingURL=PDFAcroPushButton.js.map